import FetchWrapper from '../helpers/request';
import Helpers from '../helpers';
import HtmlSanitizer from '../helpers/sanitizer';

/**
 * File Explorer.
 */
const Explorer = {

	/**
	 * Elements object.
	 */
	elements: {
		browsable: document.querySelectorAll( '.is-browsable' ),
		addBtn: document.querySelector( '#file-explorer--add__contents' ),
		items: '',
		clear: document.querySelector( '.snapshot-clear--exclusions__list' ),
		undo: document.querySelector( '.snapshot-undo--exclusions__list' ),
	},

	queue: false,
	all: false,

	/**
	 * Initialize the explorer.
	 */
	init() {
		this.exclusions = [];
		this.state = [];
		this.removedState = [];
		this.listeners();

		const $textArea = document.querySelector( '#snapshot-file-exclusions' );

		if ( $textArea ) {
			$textArea.addEventListener( 'change', function( e ) {
				e.stopImmediatePropagation();
			} );
		}
	},

	/**
	 * Clear all the exclusions.
	 */
	clearExclusions() {
		const $textArea = document.querySelector( '#snapshot-file-exclusions' );
		const $default = document.querySelector( '#snapshot-default-exclusions' );

		if ( $textArea && null !== $textArea && this.all ) {
			// Listen to the textarea change.
			$textArea.addEventListener( 'change', ( e ) => {
				const $wrap = e.target.closest( '.sui-multistrings-wrap' );
				const $lists = $wrap.querySelector( '.sui-multistrings-list' );
				const $allLists = $lists.querySelectorAll( 'li:not(.sui-multistrings-input)' );
				if ( $allLists && $allLists.length ) {
					$allLists.forEach( ( list ) => {
						list.remove();
					} );
				}
			} );
		}
		this.all = false;

		if ( $default && $default.checked === true ) {
			$default.click();
		}
	},

	/**
	 * Build the HTML to display in the explorer tree.
	 *
	 * @param {Array} exclusions
	 */
	buildListHtml( exclusions ) {
		const $wrap = document.querySelector( '.sui-multistrings-wrap' );
		const $lists = $wrap.querySelector( '.sui-multistrings-list' );
		if ( exclusions && exclusions.length ) {
			for ( const exclusion of exclusions ) {
				const li = document.createElement( 'li' );
				li.setAttribute( 'title', exclusion );

				const liSpan = document.createElement( 'span' );
				liSpan.classList.add( 'sui-icon-page' );
				liSpan.classList.add( 'sui-sm' );
				liSpan.setAttribute( 'aria-hidden', 'true' );

				const liBtn = document.createElement( 'button' );
				liBtn.classList.add( 'sui-button-close' );

				const liBtnClose = document.createElement( 'span' );
				liBtnClose.classList.add( 'sui-icon-close' );
				liBtnClose.setAttribute( 'aria-hidden', 'true' );

				const liBtnReader = document.createElement( 'span' );
				liBtnReader.classList.add( 'sui-screen-reader-text' );
				liBtnReader.innerHTML = 'Delete';

				liBtn.append( liBtnClose );
				liBtn.append( liBtnReader );

				li.append( liSpan );
				li.append( exclusion );
				li.append( liBtn );

				$lists.prepend( li );
			}
		}
	},

	/**
	 * All event listeners are declared here.
	 */
	listeners() {
		const lists = this.elements.browsable;
		const addExclusions = this.elements.addBtn;
		const snapshotExclusions = document.querySelector( '#snapshot-file-exclusions' );
		const clearExclusions = this.elements.clear;
		const $body = document.querySelector( 'body' );
		let temp = '';
		const $default = document.querySelector( '#snapshot-default-exclusions' );
		const checked = $default ? $default.checked : false;

		if ( lists ) {
			lists.forEach( ( el ) => {
				el.addEventListener( 'click', ( ev ) => {
					this.lists( ev );
				} );
			} );
		}

		if ( addExclusions ) {
			addExclusions.addEventListener( 'click', ( ev ) => {
				ev.preventDefault();
				const modalClose = document.querySelector( '#snapshot-modal-file-explorer' ).querySelector( '.file-explorer--close__modal' );
				const database = window.exclusionsList.exclusions ?? [];

				let exclusionsState = [].concat( database, this.state );
				exclusionsState = [ ... new Set( exclusionsState ) ];	// Removes any duplicate entries.

				exclusionsState = exclusionsState.map( ( item ) => HtmlSanitizer.SanitizeHtml( item ) );

				if ( exclusionsState && exclusionsState ) {
					snapshotExclusions.value = exclusionsState.join( '\n' );
					snapshotExclusions.dispatchEvent( new Event( 'change' ) );
				}
				window.exclusionsList.exclusions = exclusionsState;

				if ( exclusionsState.length >= 2 ) {
					clearExclusions.closest( 'div' ).style.display = 'flex';
				} else if ( exclusionsState.length < 2 ) {
					clearExclusions.closest( 'div' ).style.display = 'none';
				}
				this.state = [];	// reset the state, so that we can use a fresh one next time.
				modalClose.click();
			} );
		}

		if ( clearExclusions ) {
			clearExclusions.addEventListener( 'click', ( ev ) => {
				ev.preventDefault();
				temp = snapshotExclusions.value;

				window.exclusionsList.exclusions = [];
				this.all = true;
				this.clearExclusions();
				this.clearCheckedBoxesFromExplorerModal();

				Helpers.Notice.open( {
					message: window.snapshot_messages.cleared_exclusion_success,
					type: 'success',
					dismissible: true,
					id: 'snapshot-notice--clear__exclusion',
				} );

				snapshotExclusions.value = '';
				snapshotExclusions.dispatchEvent( new Event( 'change' ) );

				clearExclusions.closest( 'div' ).style.display = 'none';
			} );
		}

		if ( $body ) {
			$body.addEventListener( 'click', ( ev ) => {
				const el = ev.target;

				if ( el.classList.contains( 'snapshot-undo--exclusions__list' ) ) {
					ev.preventDefault();

					const parent = el.closest( '.sui-notice' );
					Helpers.Notice.close( parent.getAttribute( 'id' ) );

					snapshotExclusions.value = temp;
					snapshotExclusions.dispatchEvent( new Event( 'change' ) );

					window.exclusionsList.exclusions = temp.split( '\n' );

					if ( $default && false !== checked ) {
						$default.click();
					}

					temp = '';	// Clear the temporary value.
					clearExclusions.closest( 'div' ).style.display = 'flex';
				}
			} );
		}
	},

	/**
	 * Clear the checked boxes from Explorer Modal.
	 */
	clearCheckedBoxesFromExplorerModal() {
		const modal = document.querySelector( '.snapshot-modal--file__explorer' );
		const enabledItems = modal.querySelectorAll( '.node--enabled' );

		if ( enabledItems ) {
			for ( const item of enabledItems ) {
				item.classList.remove( 'node--enabled' );
				item.classList.add( 'node--disabled' );
				item.setAttribute( 'aria-selected', 'false' );
			}
		}
		this.state = [];
	},

	/**
	 * Get the ancestors list.
	 *
	 * @param {HTMLLIElement} el
	 *
	 * @return {Array} List of ancestors.
	 */
	ancestors( el ) {
		let ancestors = [];

		while ( el.parentNode && ! el.parentNode.classList.contains( 'sui-tree' ) ) {
			el = el.parentNode;

			const all = el.querySelectorAll( 'li' );

			const obj = {
				el,
			};

			if ( all && all.length ) {
				const nested = [];
				all.forEach( ( l ) => {
					nested.push( l );
				} );
				obj.children = nested;
			}

			ancestors.push( obj );
		}

		// eslint-disable-next-line dot-notation
		ancestors = ancestors.filter( ( parent ) => parent[ 'el' ].nodeName.toLowerCase() === 'li' );
		return ancestors;
	},

	/**
	 * Get all the children.
	 *
	 * @param {HTMLElement} el HTML list element.
	 *
	 * @return {Array} Empty array if there are no inner list elements.
	 */
	children( el ) {
		const children = [];
		const lists = el.querySelectorAll( 'li' );

		if ( lists ) {
			lists.forEach( ( list ) => {
				children.push( list );
			} );
		}

		return children;
	},

	/**
	 * Toggles the parent and children checkbox
	 *
	 * @param {Object} el
	 */
	toggleCheckbox( el ) {
		const list = el.closest( 'li[role=treeitem]' );
		const ancestors = this.ancestors( list );

		const status = list.getAttribute( 'aria-selected' );
		const replace = status === 'false' ? 'true' : 'false';

		list.setAttribute( 'aria-selected', replace );
		const listClasses = list.classList;

		if ( 'true' === replace ) {
			if ( listClasses.contains( 'node--disabled' ) ) {
				listClasses.remove( 'node--disabled' );
				listClasses.add( 'node--enabled' );
			}
		} else {
			listClasses.remove( 'node--enabled' );
			listClasses.add( 'node--disabled' );
		}

		if ( list.classList.contains( 'snapshot-structure--loaded' ) ) {
			const leaves = this.children( list );
			if ( leaves.length > 0 ) {
				leaves.forEach( ( leaf ) => {
					leaf.setAttribute( 'aria-selected', replace );
				} );
			}
		}

		/**
		 * Loop through all the ancestors.
		 */
		for ( const index in ancestors ) {
			const parent = ancestors[ index ];
			const children = parent.children;

			if ( children && children.length ) {
				for ( const cid in children ) {
					const child = children[ cid ];
					if ( 'false' === child.getAttribute( 'aria-selected' ) ) {
						parent.el.setAttribute( 'aria-selected', 'false' );
						child.setAttribute( 'aria-selected', 'false' );
						break;
					}
					parent.el.setAttribute( 'aria-selected', 'true' );
				}
			}
		}
	},

	/**
	 * Checks if excluded in any means.
	 *
	 * @param {string} extractedPath
	 */
	wasExcluded( extractedPath ) {
		while ( extractedPath ) {
			if ( this.state.includes( extractedPath ) || window.exclusionsList.exclusions.includes( extractedPath ) || this.removedState.includes( extractedPath ) ) {
				return true;
			}
			const lastIndex = extractedPath.lastIndexOf( '/' );
			extractedPath = extractedPath.slice( 0, lastIndex );
		}
		return false;
	},

	/**
	 * Handle sub path inclusion list.
	 *
	 * @param {string}      path   current path being considered.
	 * @param {HTMLElement} listEl current element being considered.
	 */
	handleSubPathInclusion( path, listEl ) {
		const lastIndex = path.lastIndexOf( '/' );
		const extractedPart = path.slice( 0, lastIndex );
		if ( this.wasExcluded( extractedPart ) ) {
			const siblings = [];
			let currentElement = listEl;

			while ( null !== ( currentElement = currentElement.previousElementSibling ) ) {
				siblings.push( currentElement );
			}
			currentElement = listEl;
			while ( null !== ( currentElement = currentElement.nextElementSibling ) ) {
				siblings.push( currentElement );
			}
			siblings.forEach( ( el ) => {
				this.state.push( el.dataset.path );
			} );
			if ( this.state.includes( extractedPart ) ) {
				this.state.splice( this.state.indexOf( extractedPart ), 1 );
			} else {
				const globalExclusions = window.exclusionsList.exclusions;

				if ( globalExclusions.includes( extractedPart ) ) {
					this.removedState.push( extractedPart );
					globalExclusions.splice( globalExclusions.indexOf( extractedPart ), 1 );
					const $textArea = document.querySelector( '#snapshot-file-exclusions' );
					$textArea.value = globalExclusions.join( '\n' );

					$textArea.dispatchEvent( new Event( 'change' ) );
				}
			}
			const el = document.querySelector( '[data-path="' + extractedPart + '"]' );
			this.handleSubPathInclusion( extractedPart, el );
		}
	},

	/**
	 * Handle exclusions list.
	 *
	 * @param {HTMLElement} el List element.
	 */
	handleExclusion( el ) {
		const list = el.closest( 'li[role=treeitem]' );
		const path = HtmlSanitizer.SanitizeHtml( list.dataset.path );
		if ( this.state.includes( path ) ) {
			this.state.splice( this.state.indexOf( path ), 1 );
		} else if ( window.exclusionsList.exclusions.includes( path ) ) {
			const globalExclusions = window.exclusionsList.exclusions;
			if ( globalExclusions.includes( path ) ) {
				globalExclusions.splice( globalExclusions.indexOf( path ), 1 );
				const $textArea = document.querySelector( '#snapshot-file-exclusions' );
				$textArea.value = globalExclusions.join( '\n' );

				$textArea.dispatchEvent( new Event( 'change' ) );
			}
		} else if ( 'false' === list.getAttribute( 'aria-selected' ) ) {
			if ( -1 !== path.lastIndexOf( '/' ) ) {
				this.handleSubPathInclusion( path, list );
			}
		} else if ( '/' !== path ) {
			this.state.push( path );
		}
	},

	/**
	 * Handle visibility of child elements.
	 *
	 * @param {HTMLElement} el List element.
	 */
	visibility( el ) {
		const list = el.querySelector( ':scope > ul' );

		const isExpanded = ( 'false' === el.getAttribute( 'aria-expanded' ) ) ? 'false' : 'true';

		if ( isExpanded === 'true' ) {
			el.setAttribute( 'aria-expanded', 'false' );
			list.style.display = 'none';
		} else {
			list.style.display = 'block';
			el.setAttribute( 'aria-expanded', 'true' );
		}
	},

	/**
	 * Make the AJAX request to list the children of current folder.
	 *
	 * @param {*} event
	 */
	lists( event ) {
		if ( event ) {
			event.stopPropagation();
			event.preventDefault();
		}

		const el = event.target;

		if ( el.classList.contains( 'sui-node-checkbox' ) ) {
			this.toggleCheckbox( el );
			this.handleExclusion( el );
			return;
		}

		const parent = ( 'li' !== el.nodeName.toLowerCase() ) ? el.closest( 'li' ) : el;

		if ( parent.classList.contains( 'snapshot-structure--loaded' ) ) {
			if ( parent.classList.contains( 'node--appended' ) ) {
				this.visibility( parent );
			}
			return;
		}

		if ( this.queue ) {
			// If there is already a running reuqest, we're not going to entertain multiple requests.
			return;
		}

		const SnapshotAjax = window.SnapshotAjax;
		this.queue = true;

		// Make the request.
		const req = new FetchWrapper( {
			baseURL: SnapshotAjax.ajaxurl,
		} );

		req.use( ( request ) => {
			parent.classList.add( 'is-loading' );
			parent.querySelector( '.loading-icon' ).classList.add( 'loading-icon' );

			request.credentials = 'same-origin';
			request.headers[ 'Content-Type' ] = 'application/x-www-form-urlencoded; charset=UTF-8';
			request.headers.Accept = 'application/json, text/javascript, */*;';

			const body = JSON.parse( request.body );
			const search = new URLSearchParams();

			for ( const key in body ) {
				search.append( key, body[ key ] );
			}
			request.body = search;

			return request;
		}, 'before' );

		req.use( ( response ) => {
			parent.classList.remove( 'is-loading' );
			parent.querySelector( '.loading-icon' ).classList.remove( 'loading-icon' );

			return response;
		}, 'after' );

		const res = req.post( null, {
			action: 'snapshot-file_explorer',
			_nonce: SnapshotAjax.explorer.nonce,
			spath: parent.dataset.path
		} );

		res.then( ( response ) => response.json() )
			.then( ( result ) => {
				if ( result.success !== true ) {
					window.console.error( result );
				}

				const unorderdList = document.createElement( 'ul' );
				unorderdList.setAttribute( 'role', 'group' );
				unorderdList.style.display = 'block';
				unorderdList.innerHTML = result.data.tree;

				const exclusions = window.exclusionsList.exclusions ?? [];
				const lists = unorderdList.querySelectorAll( 'li' );

				if ( lists ) {
					// Unset the content.
					unorderdList.innerHTML = '';
					lists.forEach( ( list ) => {
						// Modify the attribute based upon it's parent selection status.
						list.setAttribute( 'aria-selected', parent.getAttribute( 'aria-selected' ) );
						const path = list.getAttribute( 'data-path' );
						if ( exclusions && exclusions.includes( path ) ) {
							list.setAttribute( 'aria-selected', 'true' );
						}

						unorderdList.appendChild( list );
					} );
				}

				parent.classList.add( 'snapshot-structure--loaded' );
				parent.setAttribute( 'aria-expanded', true );
				parent.appendChild( unorderdList );
			} )
			.catch( ( err ) => {
				// Log any of the error to the console.
				window.console.log( 'Error ', err );
			} )
			.finally( () => {
				// We're done loading so free up the queue.
				this.queue = false;
			} );
	},

};

export default Explorer;
